// extracted by mini-css-extract-plugin
export var acitonButtons = "_i2-0";
export var additionalIcon = "_i2-f";
export var block = "_i2-1";
export var blockContent = "_i2-7";
export var blockDescription = "_i2-8";
export var blockIcon = "_i2-9";
export var blockTitle = "_i2-6";
export var border = "_i2-a";
export var center = "_i2-l";
export var edge = "_i2-b";
export var edgeLabel = "_i2-c";
export var edgePath = "_i2-d";
export var error = "_i2-e";
export var flowchart = "_i2-g";
export var flowchartContent = "_i2-h";
export var highlighted = "_i2-3";
export var hover = "_i2-4";
export var icon = "_i2-i";
export var left = "_i2-m";
export var navButton = "_i2-j";
export var navButtons = "_i2-k";
export var right = "_i2-n";
export var selected = "_i2-2";
export var small = "_i2-5";